<template>
  <AbsPopup id="PointBuy" title="충전하기" @close="$emit('close')" @submit="submit" :initButtonList="buttonList">
    <template #body>
      <div class="popup-body">
        <div class="addname">
          <span><b>신청인(실명)</b></span>
          <UInput type="text" line="box" placeholder="이름을 입력해 주세요" v-model="username" @focusout="focusHandler" align="center" />
        </div>
        <div class="paymentTitle">
          <!-- <icon size="xsmall" uicon="122" state="deactive" /> -->
          <b><span>충전할 금액</span></b>
        </div>
        <UInput type="text" line="box" placeholder="" v-model="cash" @focusout="focusHandler" align="right" color="active" />
        <div class="description">
          <span>충전시 최소금액은 5,000원이고, 100원 단위로 충전이 가능합니다.</span>
          <span>1회 충전 가능 금액 : <span class="require">50만원</span></span>
          <span>1일 100만원 / 월 1,000만원 충전가능</span>
        </div>
        <TabButton :list="buyList" @click="tabclick"/>
        <div class="paymentTitle">
          <!-- <icon size="xsmall" uicon="122" state="deactive" /> -->
          <b><span>결제정보</span></b>
        </div>
        <div class="paymentList">
          <li class="paymentItem cursorButton" v-for="(item, idx) in paymentList" :key="idx" @click="paymentClick(item, idx)" :class="{select: isSelect(item)}">
            <icon v-if="item.type !== 'img'" size="medium" :uicon="item.icon" :state="isSelect(item)? 'title': 'guide'" />
            <icon v-else size="medium" icon="ico-alarm-60" :state="isSelect(item)? 'title': 'guide'" />
            <span>{{ item.name }}</span>
          </li>
        </div>
        <div class="agree">
          <div>
            <input class="checkbox" type="checkbox" id="b" v-model="bcheck"/>
            <label for="b"></label>
          </div>
          <div>
            <Ubutton type="text" text="<u>스담서비스 이용약관</u>" @click.native="window.open('/terms/service')"/>,&nbsp;
            <Ubutton type="text" text="<u>유료서비스 이용약관</u>" @click.native="window.open('/terms/paidservie')"/>,&nbsp;
            <Ubutton type="text" text="<u>환불약관</u>" @click.native="window.open('/terms/refund')"/>
            <span>에 동의 합니다.</span><span class="require">*</span>
          </div>
        </div>
        <div class="agree">
          <div>
            <input type="checkbox" id="a" v-model="check"/>
            <label for="a">
              <span>위 구매조건 확인 및 결제진행에 동의</span><span class="require">*</span>
            </label>
          </div>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import TabButton from '@/components/layout/TabButton.vue'
import UInput from '@/components/base/UInput.vue'
import {getTime, numberToComma, commaToNumber} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    document.querySelector('.popup-body input').focus()
    this.$emit('loading', false)
  },
  data: () => {
    return {
      window: window,
      cash: '0',
      username: '',
      buyList: [
        {id: 0, name: '+1천원', value: 1},
        {id: 1, name: '+1만원', value: 10},
        {id: 2, name: '+3만원', value: 30},
        {id: 3, name: '+5만원', value: 50},
        {id: 3, name: '+10만원', value: 100}
      ],
      paymentList: [
        {name: '신용카드', icon: '118', value: 'card'},
        // {name: '카카오페이', icon: '145', value: 'kakaopay', type: 'img'},
        {name: '실시간계좌이체', icon: '119', value: 'trans'}
        // {name: '무통장입금', icon: '120', value: 'vbank'},
        // {name: '휴대폰', icon: '121', value: 'phone'}
      ],
      paymentSelect: null,
      check: false,
      bcheck: false
    }
  },
  name: 'PointBuy',
  watch: {
    cash (val) {
      if (val === '') {
        this.cash = numberToComma(0)
      } else if (parseInt(commaToNumber(val)) > 500000) {
        this.cash = numberToComma(500000)
      } else {
        this.cash = numberToComma(commaToNumber(val))
      }
    }
  },
  computed: {
    buttonList () {
      return [
        {name: '취소하기', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '충전하기', state: this.isSubmit, click: this.submit}
      ]
    },
    isSubmit () {
      console.log(commaToNumber(this.cash) >= 5000)
      if (this.username !== '' && this.cash !== '0' && commaToNumber(this.cash) >= 5000 && this.paymentSelect !== null && this.check === true && this.bcheck === true) {
        return 'active'
      } else {
        return 'disable'
      }
    }
  },
  methods: {
    focusHandler (e) {
      var st = commaToNumber(this.cash).toString()
      var n = parseInt(st.substring(0, st.length - 2)) * 100
      console.log(n)
      if (n > 0) {
        this.cash = numberToComma(n)
      } else {
        this.cash = numberToComma(0)
      }
    },
    tabclick (e) {
      this.cash = (commaToNumber(this.cash) + (e.value * 1000)).toString()
    },
    paymentClick (e, idx) {
      console.log('paymentClick', e, idx)
      this.paymentSelect = idx
    },
    isSelect (item) {
      return this.paymentList[this.paymentSelect] === item
    },
    submit () {
      if (this.isSubmit === 'active') {
        var ob = {
          pg: 'html5_inicis',
          pay_method: this.paymentList[this.paymentSelect].value,
          merchant_uid: this.$store.getters.id + '_' + getTime(),
          name: 'UPOINT ' + commaToNumber(this.cash),
          status: 'ready',
          custom_data: this.$store.getters.id,
          amount: commaToNumber(this.cash),
          point: commaToNumber(this.cash),
          digital: true
        }
        console.log(ob.pay_method)
        switch (ob.pay_method) {
          case 'card' :
            ob.pg = 'html5_inicis'
            // ob.pg = 'danal_tpay'
            break
          case 'trans' :
            // ob.pg = 'html5_inicis'
            ob.pg = 'danal_tpay'
            break
          case 'kakaopay' :
            ob.pg = 'kakaopay'
            break
          case 'phone' :
            ob.pg = 'danal'
            break
        }
        console.log(ob)
        this.$http.post('/api/point/buyPoint', ob).then((e) => {
          console.log(e)
          if (e.success) {
            ob.buyer_email = e.Email
            ob.buyer_name = this.username
            ob.buyer_tel = e.Phone
            window.IMP.request_pay(ob, (rsp) => {
              console.log('request_pay', ob, rsp)
              if (rsp.success) {
                this.$store.commit('chargePoint', this.$store.getters.chargePoint + commaToNumber(this.cash))
                this.$emit('submit', {type: this.status, cash: this.cash})
                // msg += '고유ID : ' + rsp.imp_uid
                // msg += '상점 거래ID : ' + rsp.merchant_uid
                // msg += '결제 금액 : ' + rsp.paid_amount
                // msg += '카드 승인번호 : ' + rsp.apply_num
              } else {
                this.$http.post('/api/point/resultBuy', rsp).then((e) => {
                  this.$emit('submit', {type: 'error', message: rsp.error_msg})
                })
              }
            })
          } else {
          }
        })
      }
    }
  },
  components: {
    AbsPopup,
    UInput,
    TabButton
  }
}
</script>

<style scoped>
.popup-body {
  margin: 10px 10px;
  width: 470px;
  text-align: left;
  line-height: 30px;
}
.popup-body .input {
  width: 100%;
  margin-bottom: 10px;
  height: 30px;
  flex: 1;
}
.popup-body .input > div {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.popup-body .input > div > span + span {
  margin-left: 10px;
}
.popup-body .description {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  margin-bottom: 20px;
}
.addname {
  display: flex;
  flex-direction: row;
}
.addname span {
  margin-right: 10px;
}
.paymentTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid var(--line-base);
  margin-bottom: 10px;
}
.paymentTitle > span {
  margin-right: 10px;
}
.paymentList {
  display: flex;
  flex-direction: row;
  height: 70px;
}
.paymentItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--line-base);
  color: var(--text-guide);
  flex: 1;
  padding-top: 10px;
}
.paymentItem:nth-child(1n+2) {
  margin-left: 5px;
}
.paymentItem span:last-child {
  font-size: 0.8em;
  margin-top: -5px;
}
.paymentItem.select {
  border: 1px solid var(--text-title);
  color: var(--text-title);
}
.agree {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}
.agree > div {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.agree > div + div {
  margin-left: 2px;
}
.agree input[type=checkbox] {
  display: none;
}
.agree input[type=checkbox] + label {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  cursor: pointer;
}
.agree input[type=checkbox] + label::before {
  content: '';
  color: var(--line-base);
  position: absolute;
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  border: 2px solid var(--line-base);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 14px;
  transform: translateY(-50%);
}
.agree input[type=checkbox]:checked + label::before {
  content: 'v';
  color: var(--active);
  border: 2px solid var(--active);
}
.agree input[type=checkbox]:checked + label {
  /* color: var(--active); */
}
.ico-alarm-60 {
  background-image: url('~@/assets/icon/logo-kakao.png');
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PointBuy.vue